import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';
import type { ReactNode } from 'react';

const badgeVariants = cva(
  'inline-flex items-center rounded font-medium',
  {
    variants: {
      variant: {
        primary: 'bg-primary text-primary-foreground',
        secondary: 'border border-border text-muted-foreground dark:border-transparent dark:bg-secondary dark:text-secondary-foreground',
        success: 'bg-success text-success-foreground',
        warning: 'bg-warning text-warning-foreground',
        info: 'bg-info text-info-foreground',
        cyan: 'bg-cyan text-cyan-foreground',
        purple: 'bg-purple text-purple-foreground',
        pink: 'bg-pink text-pink-foreground',
        orange: 'bg-orange text-orange-foreground',
        indigo: 'bg-indigo text-indigo-foreground',
        teal: 'bg-teal text-teal-foreground',
        amber: 'bg-amber text-amber-foreground',
        destructive: 'bg-destructive text-destructive-foreground',
        muted: 'bg-muted text-muted-foreground',
      },
      size: {
        sm: 'px-1.5 py-0.5 text-[11px]',
        md: 'px-2 py-0.5 text-xs',
        lg: 'px-2.5 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  }
);

interface BadgeProps extends VariantProps<typeof badgeVariants> {
  children: ReactNode;
  className?: string;
  title?: string;
}

export function Badge({ variant, size, children, className, title }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant, size }), className)} title={title}>
      {children}
    </span>
  );
}
